import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-lti',
  templateUrl: './lti.component.html',
  styleUrls: ['./lti.component.scss'],
})
export class LtiComponent implements OnInit {
  data: any;
  routersList = environment.routes;
  constructor(
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('error') == 'true')
      this.router.navigateByUrl('/');
    else {
      this.data = JSON.parse(
        this.route.snapshot.queryParamMap.get('login_data') || 'null'
      );
      this.setLocalStorage();
    }
  }
  setLocalStorage() {
    console.log(this.data)
    let authorizationData = {
      username: this.data.user.username,
      email: this.data.user.email,
      fname: this.data.user.first_name,
      lname: this.data.user.last_name,
      id: this.data.user.id,
      image_link: this.data.user.image_link,
      logged_in: true,
      social_id: this.data.user.social_id,
      social_track: this.data.user.social_track,
      role: this.data.user.role,
      trialEnd: this.data.trialEnd,
      country: this.data.user.country,
      robopal: this.data.RoboPalAuth ? this.data.RoboPalAuth.permission : '',
      robopal_end: this.data.RoboPalAuth ? this.data.RoboPalAuth.end_date : '',
      robopal_cancelled: this.data.RoboPalAuth
        ? this.data.RoboPalAuth.cancelled
        : '',
      status: this.data.status
        ? this.data.status
        : this.data.user.account?.status
        ? this.data.user.account?.status
        : this.data.account?.status,
      account_type: this.data.accountType,
      invited: this.data.invited,
      is_admin: this.data.user.is_admin,
      isCompetitionStudent: this.data.user.isCompetitionStudent,
      CompetitionStudentGrade: this.data.user.CompetitionStudentGrade,
      CompetitionCountry: this.data.user.CompetitionCountry,
      isOrangeServiceUser: this.data.user.isOrangeServiceUser,
      currentJourneyId: this.data.user.user_position.JourneyId,
      is_ceibal_user: this.data.user.is_ceibal_user,
      "inCeibalOlympiad":this.data.user?.inCeibalOlympiad,
      is_eupheusschoolos_user:this.data.user.user.is_eupheusschoolos_user
    };
    localStorage.setItem('satellizer_token', this.data.token.token);
    localStorage.setItem(
      'AuthorizationData',
      JSON.stringify(authorizationData)
    );
    localStorage.setItem('stripe_user', this.data.user_stripe);
    localStorage.setItem(
      'score',
      JSON.stringify({
        xp: this.data.user.score.xp,
        coins: this.data.user.score.coins,
      })
    );
    this.cookieService.set('robogarden_user', 'true');
    this.redirect();
  }
  redirect() {
    let role = this.data.user.role;
    if (role == 'school_admin') {
      window.location.replace(this.routersList.dashboard);
    } else if (role == 'teacher')
      window.location.replace(this.routersList.TeacherDashboard);
    else if (role == 'student' || role == 'user')
      window.location.replace(this.routersList.index_journeys);
  }
}
